import { ParseConsistentBase64JsonPayloadUseCase } from '../Utils/ParseConsistentBase64JsonPayload';
import { Result } from '@standardnotes/domain-core';
export class AsymmetricStringGetAdditionalData004 {
    constructor(crypto) {
        this.crypto = crypto;
        this.parseBase64Usecase = new ParseConsistentBase64JsonPayloadUseCase(this.crypto);
    }
    execute(dto) {
        const [_, __, ___, additionalDataString] = dto.encryptedString.split(':');
        const additionalData = this.parseBase64Usecase.execute(additionalDataString);
        return Result.ok(additionalData);
    }
}
